<div class="center">
    <p *ngIf="!isLinked"
    >{{ ('Click the button below and follow the instructions to link {}' | translate).replace('{}', 'Manava') }}</p>
    <button
            (click)="clickHandler(isLinked ? 'remove' : 'connect')"
            mat-stroked-button
    >
        {{ ( isLinked ? "Remove" : "Link Manava" ) | translate }}
    </button>
</div>